const data2 = [
    {
      title: "Impulsa tu cambio de carrera",
      background: "/assets/images/dojopy/profile_1.png",
    },
    {
      title: "Si eres principiante en programación	",
      background: "/assets/images/dojopy/profile_4.png",
    },
    {
      title: "Potencia tu CV con habilidades tech	",
      background: "/assets/images/dojopy/profile_2.png",
    },
    {
      title: "Emprende y lidera proyectos digitales	",
      background: "/assets/images/dojopy/profile_5.png",
    },
    {
      title: "Genera más ingresos con una profesión rentable",
      background: "/assets/images/dojopy/profile_3.png",
    },
  ];
  
  export default data2;